import { render } from "./EditTypeUser.vue?vue&type=template&id=0c4ed820&scoped=true"
import script from "./EditTypeUser.vue?vue&type=script&lang=js"
export * from "./EditTypeUser.vue?vue&type=script&lang=js"

import "./EditTypeUser.vue?vue&type=style&index=0&id=0c4ed820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4ed820"]])

export default __exports__